<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>售后服务</el-breadcrumb-item>
      <el-breadcrumb-item>售后服务单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入售后单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select">
              <el-option label="请选择售后状态" value="-1"></el-option>
              <el-option label="待处理" value="0"></el-option>
              <el-option label="处理中" value="1"></el-option>
              <el-option label="已处理" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.glasstype" placeholder="请选择">
              <el-option
                v-for="item in GlassTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sn" @keyup.enter.native="clicksearch" placeholder="请输入设备SN"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.aftersalestype" @keyup.enter.native="clicksearch" placeholder="请输入售后分类"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.aftersalesinfo" @keyup.enter.native="clicksearch" placeholder="请输入售后原因"></el-input>
          </el-form-item>
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item label="">
            <el-input v-model="keywords.jigouname" @keyup.enter.native="clicksearch" placeholder="请输入机构名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table v-loading="loading" :data="dataList" ref="dataList" border stripe>
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.Sublist" height="200" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
                <el-table-column label="处理方式"  prop="Process"></el-table-column>
                <el-table-column label="单次维修金额"  prop="Money"></el-table-column>
                <el-table-column label="附件">
                  <template v-slot="scope">
                    <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="填单人" prop="Adminusername"></el-table-column>
                <el-table-column label="录入时间" prop="Createtime"></el-table-column>
                <el-table-column prop="operation" label="操作">
                  <template v-slot="scope">
                    <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickTrackEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickTrackDelete(scope.row)" v-if="SubRule_AfterSalesServiceOrderTrack_Delete">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Orderid" label="售后单号" min-width="10%"></el-table-column>
          <el-table-column prop="Orderstatusname" label="售后状态" min-width="6%">
            <template slot-scope="props">
              <span class="blue" style="margin-left: 0; margin-right: 5px;color: #48c9b0;" @click="toogleExpand(props.row)">{{props.row.Orderstatusname}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Glasstype" label="设备型号" min-width="6%"></el-table-column>
          <el-table-column prop="Sn" label="设备SN" min-width="10%"></el-table-column>
          <el-table-column prop="Jigouname" label="设备所属机构" min-width="10%"></el-table-column>
          <el-table-column prop="Aftersalestype" label="售后分类" min-width="6%"></el-table-column>
          <el-table-column prop="Aftersalesinfo" label="售后原因" min-width="15%"></el-table-column>
          <el-table-column label="附件" min-width="10%">
            <template v-slot="scope">
              <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Moneytotal" label="总维修金额" min-width="6%"></el-table-column>
          <el-table-column prop="Adminusername" label="填单人" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="录入时间" min-width="8%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">编辑售后服务单</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickTrackAdd(scope.row)">添加跟踪处理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加售后服务单 start -->
      <el-tab-pane label="添加售后服务单" name="second">
        <el-form :model="addForm" ref="addFormRef" label-width="170px">
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">设备型号</span>
            </label>
            <el-select v-model="addForm.glasstype" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in GlassTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">设备SN</span>
            </label>
            <el-input v-model="addForm.sn"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">售后分类</span>
            </label>
            <el-input v-model="addForm.aftersalestype"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">售后原因</span>
            </label>
            <el-input type="textarea" :rows="5" v-model="addForm.aftersalesinfo"></el-input>
          </el-form-item>
          <el-form-item label="附件(可选)" class="addAdminForm">
            <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加售后服务单 end -->

      <el-tab-pane label="编辑售后服务单" name="three" disabled="disabled">
        <AfterSalesServiceOrderEdit ref="SubVuethree" v-on:triggerFunc="BackToFirst()"></AfterSalesServiceOrderEdit>
      </el-tab-pane>

      <el-tab-pane label="添加跟踪处理" name="four" disabled="disabled">
        <AfterSalesServiceOrderTrackAdd ref="SubVuefour" v-on:triggerFunc="BackToFirst()"></AfterSalesServiceOrderTrackAdd>
      </el-tab-pane>

      <el-tab-pane label="编辑跟踪处理" name="five" disabled="disabled">
        <AfterSalesServiceOrderTrackEdit ref="SubVuefive" v-on:triggerFunc="BackToFirst()"></AfterSalesServiceOrderTrackEdit>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import AfterSalesServiceOrderEdit from '@/componentsSubVue/AfterSalesServiceOrderEdit.vue'
import AfterSalesServiceOrderTrackAdd from '@/componentsSubVue/AfterSalesServiceOrderTrackAdd.vue'
import AfterSalesServiceOrderTrackEdit from '@/componentsSubVue/AfterSalesServiceOrderTrackEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf,
    AfterSalesServiceOrderEdit,
    AfterSalesServiceOrderTrackAdd,
    AfterSalesServiceOrderTrackEdit
  },
  name: 'MyAfterSalesServiceOrder',
  data () {
    return {
      loading: false,
      activeName: 'first',
      GlassTypeOptions:[],
      // 查询
      keywords: {
        orderid: '',
        orderstatus: '-1',
        glasstype: '',
        sn: '',
        aftersalestype: '',
        aftersalesinfo: '',
        begintime: '',
        endtime: '',
        jigouname: ''
      },
      addForm: {
        glasstype: '',
        sn: '',
        aftersalestype: '',
        aftersalesinfo: '',
        attachment: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      SubRule_AfterSalesServiceOrderTrack_Delete: false,
      rowToogle: null
    }
  },
  mounted () {
    this.apiGetAfterSalesServiceOrderNum()
    this.apiGetAfterSalesServiceOrderList()
    this.GlassTypeOptions = Vue.prototype.FunGetAfterSalesServiceGlasstype()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_AfterSalesServiceOrderTrack_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_AfterSalesServiceOrderTrack_Delete = true
      }
    })
  },
  methods: {
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.attachment = url
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    BackToFirst () {
      this.activeName = 'first'
      this.apiGetAfterSalesServiceOrderList()
    },
    toogleExpand (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id !== item.Id) {
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row)
      this.rowToogle = row
    },
    toogleExpandManual (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Id == item.Id) {
          $table.toggleRowExpansion(item, true)
        }
      })
    },
    // 添加售后服务单
    clickadd () {
      this.apiAddAfterSalesServiceOrder()
    },
    // 编辑售后服务单
    clickedit (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    // 添加跟踪处理
    clickTrackAdd (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData(row)
    },
    // 编辑跟踪处理
    clickTrackEdit (row) {
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData(row)
    },
    // 删除跟踪处理
    clickTrackDelete (row) {
      this.$confirm('是否删除此跟踪处理?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteAfterSalesServiceOrderTrack(row.Id,row.Orderid)
      })
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetAfterSalesServiceOrderNum()
      this.apiGetAfterSalesServiceOrderList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetAfterSalesServiceOrderList()
    },
    apiGetAfterSalesServiceOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        glasstype: that.keywords.glasstype,
        sn: that.keywords.sn,
        aftersalestype: that.keywords.aftersalestype,
        aftersalesinfo: that.keywords.aftersalesinfo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouname: that.keywords.jigouname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetAfterSalesServiceOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetAfterSalesServiceOrderList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        glasstype: that.keywords.glasstype,
        sn: that.keywords.sn,
        aftersalestype: that.keywords.aftersalestype,
        aftersalesinfo: that.keywords.aftersalesinfo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouname: that.keywords.jigouname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetAfterSalesServiceOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Attachments = []
              if (that.dataList[i].Attachment.length > 1) {
                that.dataList[i].Attachments = that.dataList[i].Attachment.split('@@@')
              }
              //子列表里面还是有附件
              for (var j = 0; j < that.dataList[i].Sublist.length; j++){
                that.dataList[i].Sublist[j].Attachments = []
                if (that.dataList[i].Sublist[j].Attachment.length > 1) {
                  that.dataList[i].Sublist[j].Attachments = that.dataList[i].Sublist[j].Attachment.split('@@@')
                }
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiDeleteAfterSalesServiceOrderTrack: function (id,orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id,
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteAfterSalesServiceOrderTrack, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetAfterSalesServiceOrderNum()
            that.apiGetAfterSalesServiceOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddAfterSalesServiceOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glasstype: this.addForm.glasstype,
        sn: this.addForm.sn,
        aftersalestype: this.addForm.aftersalestype,
        aftersalesinfo: this.addForm.aftersalesinfo,
        attachment: this.addForm.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddAfterSalesServiceOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetAfterSalesServiceOrderNum()
            that.apiGetAfterSalesServiceOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .cell {
      white-space: pre-wrap;
  }
</style>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select1 {
    width: 109px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

.productdata3 {
  padding-right: 5px;
}

.box-card{
    margin-top: 5px;
    margin-bottom: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
